import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table, Typography } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import { regFenToYuan } from '@/util/money';
import { FloatConversion } from '@/util/conversion';
import { Tooltip } from 'antd';

const { Text } = Typography;
const floatConversion = new FloatConversion();

const TableBox = ({
    shippingFees: {
        dataList = [],
        pageNum,
        pageSize,
        resultTotal
    },
    onPageChange,
    onTableOperate,
    curTabID
}) => {

    const onOperateCell = (text, item) => {
        return <div className={styles.action}>
            {process.env.TYPE == 'OC' ? <>
                {text == 1 ? <div className={styles.item} onClick={() => onTableOperate(text, 'look')} >查看</div>
                    : <div className={styles.item} onClick={() => onTableOperate(text, 'edit')} >编辑</div>}
            </> : <>
                <div className={styles.item} onClick={() => onTableOperate(text, 'edit')} >编辑</div>
            </>}

            {text != 1 && <div className={styles.item} onClick={() => onTableOperate(text, 'remove')} >删除</div>}
            {text != 1 && <div className={styles.item} onClick={() => onTableOperate(text, 'copy', item)} >复制</div>}
            {text != 1 ? (<>
                <div className={styles.item} onClick={() => onTableOperate(text, 'control', item)} >运费调控</div>
                <div className={styles.item} onClick={() => onTableOperate(text, 'log', item)} >运费调控记录</div>
            </>) : null}
        </div>;
    };

    const renderCompanyTemplateName = (text) => {
        return (<Tooltip placement="topLeft" title={text}>{text}</Tooltip>);
    };

    const userColumns = [
        {
            title: '模板名称',
            dataIndex: 'templateName',
            key: 'templateName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '地域',
            dataIndex: 'cityNames',
            key: 'cityNames',
            width: '80%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'templateId',
            key: 'templateId',
            width: '300px',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    const companyColumns = [
        {
            title: '模板名称',
            dataIndex: 'templateName',
            key: 'templateName',
            width: '80%',
            align: 'left',
            onCell: tooltipStyle,
            render: renderCompanyTemplateName
        },
        {
            title: '操作',
            dataIndex: 'templateId',
            key: 'templateId',
            width: '300px',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    const columns = [userColumns, userColumns];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.templateId}
            columns={columns[curTabID - 1]}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={onPageChange}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    shippingFees: PropTypes.object,//表格数据
    onTableOperate: PropTypes.func,//表格操作
    curTabID: PropTypes.string,
};

export default TableBox;